import report_akt from './components/report_akt.vue';
import akt from './components/akt.vue';


export default {
  routes: [
    {
      path: '/',
      component:report_akt,
      name:'report_akt'
    },
    {
      path: '/report_akt',
      component:report_akt,
      name:'report_akt_'
    },
    {
      path: '/akt',
      component:akt,
      name:'akt'
    }
  ]
};
